import { render, staticRenderFns } from "./PopupPostViewer.vue?vue&type=template&id=3f432624&scoped=true"
import script from "./PopupPostViewer.vue?vue&type=script&lang=js"
export * from "./PopupPostViewer.vue?vue&type=script&lang=js"
import style0 from "./PopupPostViewer.vue?vue&type=style&index=0&id=3f432624&prod&scoped=true&lang=css"
import style1 from "./PopupPostViewer.vue?vue&type=style&index=1&id=3f432624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f432624",
  null
  
)

export default component.exports